export const CURRENT_CONFIG = {

  // license — Waypoint360: injected at build time from CI secrets (VITE_DJI_*), never committed.
  // These are the DJI app credentials; leaking appKey/appLicense in git is why they used to live
  // only on the server (and got wiped by a src sync). vite.config.ts wires the env into the bundle.
  appId: import.meta.env.VITE_DJI_APP_ID || '', // apply on the DJI developer website
  appKey: import.meta.env.VITE_DJI_APP_KEY || '',
  appLicense: import.meta.env.VITE_DJI_APP_LICENSE || '',

  // http — Waypoint360: the public prod gateway domain (not secret). Caddy fronts TLS + routing.
  baseURL: 'https://dji-op.waypoint360.eu/', // This url must end with "/".
  websocketURL: 'wss://dji-op.waypoint360.eu/api/v1/ws',

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'Please enter the rtmp access address.', // Example: 'rtmp://192.168.1.1/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  amapKey: 'Please enter the amap key.',

}
